import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from "react-router-dom";
import BasePage from '../components/BasePage';
import BackButton from '../components/Buttons/BackButton';
import { Menu, MenuItem } from "../components/Menu";
import TimeTracker from '../components/TimeTracker';

const Tickets = (props) => {
    const [isOpen, setIsOpen] = useState(false);

    const openMenu = () => setIsOpen(!isOpen);
    const closeMenu = () => setIsOpen(false);

    const elements = [
        {
            key: 'nouveau',
            to: 'tickets/nouveau',
            icon: 'fa-solid fa-comment',
            title: 'Nouvelle demande'
        },
        {
            key: 'list',
            to: 'tickets/liste',
            icon: 'fa-solid fa-clipboard-list',
            title: 'Toutes mes demandes'
        }
    ];

    const content = (data) => (
        <div id="tickets" className="flex flex-col h-full">
            <div className="header-interne flex justify-between items-center bg-[rgb(140_200_60/var(--tw-bg-opacity,1))] p-4">
                <BackButton />
                <h1>{props.title}</h1>
                <button
                    className="m-2 z-[1001] text-white"
                    onClick={openMenu}
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none"
                         stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                         className="lucide lucide-menu">
                        <line x1="4" x2="20" y1="12" y2="12"/>
                        <line x1="4" x2="20" y1="6" y2="6"/>
                        <line x1="4" x2="20" y1="18" y2="18"/>
                    </svg>
                </button>
            </div>

            {/* Affichage du compteur temps */}
            <div className="p-4">
                <TimeTracker compteur={data.compteur_temps} />
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-4">
                {elements.map((el) => (
                    <div key={el.key} className="mb-5 sm:flex-1 basis-1/4">
                        <MenuItem url={el.to} name={el.title} icon={el.icon} />
                    </div>
                ))}
            </div>

            <Menu isOpen={isOpen} openMenu={openMenu} closeMenu={closeMenu} />
        </div>
    );

    return <BasePage content={content} title={props.title ?? "Demande d'assistance"} />;
};

export default Tickets;
